import React, { useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import "./Projects.css";
import pro1p1 from "../../../images/project1-p1.png";
import pro2p1 from "../../../images/project2-p1.png";
import pro3p1 from "../../../images/project3-p1.png";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

const Projects = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Container data-aos="fade-right" className="font mt-5 ">
      <h1 className="text-center">
        Some of <span className="heading">My Works</span>
      </h1>
      <Container className=" mt-5 p-5 project-bg   ">
        <Row className="text-center gy-4">
          <Col sm={12} md={6} lg={4}>
            <div className=" border border-3 rounded border-info project-container">
              <div className="">
                <img src={pro1p1} className="img-fluid" alt="" />
                <div className="mt-2">
                  <h4>AlGO DIGITAL</h4>
                  <p className="text-secondary">
                    Algo Digital is a digital service selling website where a
                    user can buy digital services like web design, SEO, content
                    writing and social media marketing.
                  </p>
                  <Button variant="info" className=" mb-3 fw-bold">
                    <Link to="/project01" className="project-link">
                      See Details
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col sm={12} md={6} lg={4}>
            <div className=" border border-3 rounded border-info project-container">
              <div className="box">
                <img src={pro2p1} className="img-fluid" alt="" />
                <div className="mt-2">
                  <h4>Travel Bizz</h4>
                  <p className="text-secondary">
                    It is a Tourism Website. On this website, a user can book a
                    Tour place to enjoy his vacation. Beside a user can read
                    latest tour blogs.
                  </p>
                  <Button variant="info" className=" mb-3 fw-bold">
                    <Link to="/project02" className="project-link">
                      See Details
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col sm={12} md={6} lg={4}>
            <div className=" border border-3 rounded border-info project-container">
              <div className="">
                <img src={pro3p1} className="img-fluid" alt="" />
                <div className="mt-2">
                  <h4>Star HealthCare BD</h4>
                  <p className="text-secondary">
                    It is a website where a patient can easily get treatment for
                    his desired disease. A user can select his service according
                    to his disease.
                  </p>
                  <Button variant="info" className=" mb-3 fw-bold">
                    <Link to="/project03" className="project-link">
                      See Details
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Projects;
